import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssueTypesSchemesRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-types-schemes-manage',
	path: '/jira/settings/issues/issue-type-schemes',
};
